import * as React from 'react';

import {EmptyAddCard} from 'shells/card/empty-add-card';
import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {NextStepIcon} from 'shells/icon/svg/next-step-icon';
import {TwoLine} from 'shells/two-line/two-line';
import {TwoLineButtonCard} from 'shells/two-line/two-line-button-card';

import type {GetDripSequence_campaign_goal as GoalFragment} from 'nutshell-graphql-types';

import {getColor} from '../color-icon-variants';
import type {Variant} from '../color-icon-variants';

import styles from './next-step-card.module.css';

type Props = {
    isLoading: boolean;
    goal: GoalFragment | null | undefined;
    onClick?: (goalId: string) => void;
    variant?: Variant;
};

export function NextStepCard(props: Props) {
    const {goal, onClick} = props;
    const color = getColor(props.variant, colors.plum);

    if (goal && goal.action && !props.isLoading) {
        return (
            <TwoLineButtonCard
                // @ts-expect-error
                borderColor={color}
                onClick={onClick ? () => onClick(goal.id) : undefined}
            >
                <TwoLine
                    icon={NextStepIcon}
                    iconSize={20}
                    iconColor={color}
                    topRow={
                        <span>
                            <b>Next step:</b>&nbsp;{goal.action.humanReadableTitle}
                        </span>
                    }
                    bottomRow={goal.action.humanReadableSubtitle}
                    isLargeWithSmallBottomRow={true}
                />
            </TwoLineButtonCard>
        );
    }

    return (
        <div className={styles['add-next-step-container']}>
            <EmptyAddCard
                text='Add a next step'
                onClick={onClick ? () => onClick('NEW') : () => {}}
                background='white'
                size='small'
                withoutIcon={true}
                color={color}
                isLoading={props.isLoading}
            />
        </div>
    );
}
